var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceRangeFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47254 0L11.1841 0.81593L12 6.52748L6.69643 11.831C6.47113 12.0563 6.10586 12.0563 5.8805 11.831L0.168988 6.11952C-0.0563293 5.89416 -0.0563293 5.52889 0.168988 5.30353L5.47254 0ZM7.10445 4.89557C7.55505 5.34623 8.28564 5.34623 8.7363 4.89557C9.1869 4.44496 9.1869 3.71435 8.7363 3.26372C8.28564 2.8131 7.55505 2.8131 7.10445 3.26372C6.65379 3.71435 6.65379 4.44496 7.10445 4.89557Z",
    fill: "#0F090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceRangeFilterIcon);
export default __webpack_public_path__ + "static/media/price-range-filter-icon.40d5912fb4a70ecfcb5a01e6debf569d.svg";
export { ForwardRef as ReactComponent };